// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymentMethod_title__2Dyik","payment":"PaymentMethod_payment__nqRxF","link":"PaymentMethod_link__2Lge-"};